import { useEffect, useState } from 'react'
import { DUPLICATE_UPLOAD_ID_EXTENSION } from '../../../constants'
import CreationToolOutputType from '../../../types/output-type'
import { CreationToolUploadSource } from '../types'

export function useDuplicatableType(
    source: CreationToolUploadSource,
    uploadSources: CreationToolUploadSource[]
): CreationToolOutputType | undefined {
    const [duplicatableType, setDuplicatableType] = useState<CreationToolOutputType | undefined>()

    useEffect(() => {
        const uploadIds: string[] = uploadSources.map(src => src.id)

        // already has duplicate or is a duplicate
        if (source.isDuplicate || uploadIds.indexOf(`${source.id}${DUPLICATE_UPLOAD_ID_EXTENSION}`) > -1) {
            setDuplicatableType(undefined)
            return
        }

        // clips can upload as gifs
        if (source.outputType === CreationToolOutputType.Video) {
            setDuplicatableType(CreationToolOutputType.Gif)
            return
        }

        // gifs where the source has sound can upload as clips
        if (source.outputType === CreationToolOutputType.Gif && source.source.hasAudio) {
            setDuplicatableType(CreationToolOutputType.Video)
            return
        }

        setDuplicatableType(undefined)
    }, [source, uploadSources, setDuplicatableType])

    return duplicatableType
}
